export default function reportWebVitals() {
  import('web-vitals').then(webVitals => {
    webVitals.onCLS(console.log);
    webVitals.onFID(console.log);
    webVitals.onLCP(console.log);
    webVitals.onTTFB(console.log);
  });
}
